import { Container, ScrollArea, Table, Center, Text, Loader, Group, Paper, Pagination, Stack } from '@mantine/core';
import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRepeat, faDownload, faPlaneLock } from '@fortawesome/free-solid-svg-icons';
import NavbarLink from './Links';
import { showNotification } from '@mantine/notifications';

function safeUrl(input) {
    try {
        const url = new URL(input);
        if (url.protocol !== "https:" && url.protocol !== "http:") {
            throw new Error("Invalid protocol");
        }
        return url.toString();
    } catch {

        return null;
    }
}

const RecargaFunction = () => {
    fetch(process.env.REACT_APP_API_ENP + "/sscn-back/api/alertas/updateData?id=1",
        {
            method: "GET",
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
                "Content-Type": "application/json",
            },
        }
    )
        .then((response) => {
            return response.json().then((rj) => {
                if (!response.ok) {
                    throw new Error(`HTTP error while send sqs: ${rj.message}`);
                }

                return rj;
            });
        })
        .then((data) => {
            showNotification({
                title: 'Listo!',
                message: 'Tarea enviada con exito',
                color: '#fff',
                styles: (theme) => ({
                    root: {
                        backgroundColor: '#25A661',
                        borderColor: '#25A661',
                        '&::before': { backgroundColor: theme.white },
                    },
                    title: { color: theme.white },
                    description: { color: theme.white },
                    closeButton: {
                        color: theme.white,
                    },
                }),
                autoClose: true,
            })
        })
        .catch((error) => {
            showNotification({
                title: 'Error!',
                message: error.response?.data?.error ? error.response.data.error : error.message,
                color: '#fff',
                styles: (theme) => ({
                    root: {
                        backgroundColor: '#E93F19',
                        borderColor: 'E93F19',
                        '&::before': { backgroundColor: theme.white },
                    },
                    title: { color: theme.white },
                    description: { color: theme.white },
                    closeButton: {
                        color: theme.white,
                    },
                }),
                autoClose: false,
            })
        });
}

const DescargaFunction = () => {
    fetch(process.env.REACT_APP_API_ENP + "/sscn-back/api/utils/getS3Link?id=2",
        {
            method: "GET",
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
                "Content-Type": "application/json",
            },
        }
    )
        .then((response) => {
            if (!response.ok) {
                throw new Error(`HTTP error while getting Download link: ${response.status}`);
            }
            return response.json();
        })
        .then((data) => {

            const s3Url = data?.link;
            if (!s3Url) throw new Error("S3 URL not found in response");
            showNotification({
                title: 'Listo!',
                message: 'Iniciando descarga del archivo',
                color: '#fff',
                styles: (theme) => ({
                    root: {
                        backgroundColor: '#25A661',
                        borderColor: '#25A661',
                        '&::before': { backgroundColor: theme.white },
                    },
                    title: { color: theme.white },
                    description: { color: theme.white },
                    closeButton: {
                        color: theme.white,
                    },
                }),
                autoClose: true,
            });
            const link = document.createElement("a");
            link.href = s3Url; 
            // const validatedUrl = safeUrl(s3Url);
            // if (!validatedUrl) return;
            // const link = document.createElement("a");
            // link.href = encodeURI(validatedUrl); 
            link.download = "alertas.csv"; // or .csv, .txt, etc.

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
        .catch((err) => {
            showNotification({
                title: 'Error!',
                message: err.response?.data?.error ? err.response.data.error : err.message,
                color: '#fff',
                styles: (theme) => ({
                    root: {
                        backgroundColor: '#E93F19',
                        borderColor: 'E93F19',
                        '&::before': { backgroundColor: theme.white },
                    },
                    title: { color: theme.white },
                    description: { color: theme.white },
                    closeButton: {
                        color: theme.white,
                    },
                }),
                autoClose: false,
            })
        });
}

const buttonsTable = [
    { icon: faRepeat, label: 'Actualizar Datos', onClick: RecargaFunction },
    { icon: faDownload, label: 'Descarga CSV', onClick: DescargaFunction }
];



const recordsPerPage = 10;

const TableAlerts = ({ heigth }) => {
    const [allData, setAllData] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);

    const totalPages = Math.ceil(allData.length / recordsPerPage);



    const links = buttonsTable.map((link) => (
        <NavbarLink {...link} key={link.label} />
    ));

    useEffect(() => {
        setLoading(true);
        fetch(process.env.REACT_APP_API_ENP + "/sscn-back/api/utils/getS3Link?id=1", {
            method: "GET",
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error while getting S3 link! status: ${response.status}`);
                }
                return response.json();
            })
            .then((data) => {
                const s3Url = data?.link; // Adjust based on the actual response structure                
                if (!s3Url) throw new Error("S3 URL not found in response");
                return fetch(s3Url);
            })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error while fetching S3 data! status: ${response.status}`);
                }
                return response.json(); // Assuming the file on S3 is JSON
            })
            .then((json) => {
                setAllData(json);
            })
            .catch((err) => {
                showNotification({
                    title: 'Error!',
                    message: err.response?.data?.error ? err.response.data.error : err.message,
                    color: '#fff',
                    styles: (theme) => ({
                        root: {
                            backgroundColor: '#E93F19',
                            borderColor: 'E93F19',
                            '&::before': { backgroundColor: theme.white },
                        },
                        title: { color: theme.white },
                        description: { color: theme.white },
                        closeButton: {
                            color: theme.white,
                        },
                    }),
                    autoClose: false,
                })
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    // Calculate sliced data for current page
    const paginatedData = allData.slice(
        (currentPage - 1) * recordsPerPage,
        currentPage * recordsPerPage
    );

    const rows = paginatedData.map((element, index) => (
        <Table.Tr key={index}>
            <Table.Td style={{ textAlign: 'center' }}>{element.alerta}</Table.Td>
            <Table.Td style={{ textAlign: 'center' }}>{element.tipoVuelo}</Table.Td>
            <Table.Td style={{ textAlign: 'center' }}>{element.Guias}</Table.Td>
            <Table.Td style={{ textAlign: 'center' }}>{element.rapidVsOracle}</Table.Td>
            <Table.Td style={{ textAlign: 'center' }}>{element.rapidVsOracleMXN}</Table.Td>
            <Table.Td style={{ textAlign: 'center' }}>{element.skyVsOracle}</Table.Td>
            <Table.Td style={{ textAlign: 'center' }}>{element.skyVsOracleMXN}</Table.Td>
            <Table.Td style={{ textAlign: 'center' }}>{element.skyVsRapid}</Table.Td>
            <Table.Td style={{ textAlign: 'center' }}>{element.skyVsRapidMXN}</Table.Td>
        </Table.Tr>
    ));

    return (
        <>
            <div style={{ gridColumn: '1 / -1' }}>
                <Stack spacing="md" align="flex-end">
                    <Paper height={2} shadow="lg" radius="lg" withBorder p={0}>
                        <Group justify="center" gap={0}>
                            {links}
                        </Group>
                    </Paper>
                </Stack>
            </div>

            <div style={{ gridColumn: '1 / -1' }}>
                <Paper shadow="xl" radius="xl" withBorder p="xl">
                    {loading ? (
                        <Center h={heigth}>
                            <Loader color="rgba(250, 0, 115, 1)" type="dots" size={100} />
                        </Center>
                    ) : allData.length !== 0 ? (
                        <ScrollArea h={heigth}>
                            <Table stickyHeader>
                                <Table.Thead>
                                    <Table.Tr>
                                        <Table.Th style={{ textAlign: 'center' }}>Tipo Alerta</Table.Th>
                                        <Table.Th style={{ textAlign: 'center' }}>Tipo vuelo</Table.Th>
                                        <Table.Th style={{ textAlign: 'center' }}>Guias</Table.Th>
                                        <Table.Th style={{ textAlign: 'center' }}>Rapid Vs Oracle</Table.Th>
                                        <Table.Th style={{ textAlign: 'center' }}>Rapid Vs Oracle(MXN)</Table.Th>
                                        <Table.Th style={{ textAlign: 'center' }}>Sky Vs Oracle</Table.Th>
                                        <Table.Th style={{ textAlign: 'center' }}>Sky Vs Oracle(MXN)</Table.Th>
                                        <Table.Th style={{ textAlign: 'center' }}>Sky Vs Rapid</Table.Th>
                                        <Table.Th style={{ textAlign: 'center' }}>Sky Vs Rapid(MXN)</Table.Th>
                                    </Table.Tr>
                                </Table.Thead>
                                <Table.Tbody>{rows}</Table.Tbody>
                            </Table>
                        </ScrollArea>
                    ) : (
                        <Center h={heigth}>
                            <Container>
                                <Text c="dimmed" size="lg" ta="center" p={36}>
                                    Sin datos encontrados
                                </Text>
                                <Text c="dimmed" size="lg" ta="center">
                                    <FontAwesomeIcon icon={faPlaneLock} size="3x" />
                                </Text>
                            </Container>
                        </Center>
                    )}
                </Paper>
            </div>

            {/* Pagination control */}
            {!loading && totalPages > 1 && (
                <div style={{ gridColumn: '1 / -1' }}>
                    <Stack spacing="md" align="flex-end">
                        <Paper height={2} shadow="lg" radius="lg" withBorder p="sm">
                            <Pagination
                                color="rgba(2, 12, 65, 1)"
                                total={totalPages}
                                value={currentPage}
                                onChange={setCurrentPage}
                            />
                        </Paper>
                    </Stack>
                </div>
            )}
        </>
    );
};

export default TableAlerts;